import React from 'react';
import { Link } from 'react-router-dom';

/**
 * 404 Not Found page following USWDS design patterns.
 * Provides a clear message and a link back to the board list.
 */
export function NotFoundPage(): React.ReactElement {
  return (
    <main className="usa-section" role="main">
      <div className="grid-container">
        <h1 className="font-heading-xl">Page not found</h1>
        <p className="usa-intro">
          We can't find the page you're looking for. It might have been moved or no longer exists.
        </p>
        <p className="margin-top-2">
          <strong>Error 404</strong>
        </p>
        <nav aria-label="Page not found navigation" className="margin-top-3">
          <Link to="/boards" className="usa-button">
            Go to Boards
          </Link>
        </nav>
      </div>
    </main>
  );
}
